import { useState, useEffect } from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { Modal } from '@shared/components/ui/Modal';
import {
  AI_INTERVIEW_EXTRA_COLUMN_META,
  type AiInterviewExtraColumnKey,
  loadAiInterviewsTablePolicy,
  saveAiInterviewsTablePolicy,
} from './aiInterviewsListPreferences';

export function AiInterviewsConfigureColumnsModal({
  open,
  onClose,
  orgId,
  onSave,
}: {
  open: boolean;
  onClose: () => void;
  orgId: string | null;
  onSave: () => void;
}) {
  const [local, setLocal] = useState<AiInterviewExtraColumnKey[]>([]);

  useEffect(() => {
    if (open && orgId) {
      setLocal(loadAiInterviewsTablePolicy(orgId).extraColumns);
    }
  }, [open, orgId]);

  if (!orgId) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Configure columns"
      subtitle="Add optional fields to the AI interviews table"
      icon={<FileSpreadsheet className="w-4 h-4" />}
      size="md"
    >
      <div className="space-y-2">
        {AI_INTERVIEW_EXTRA_COLUMN_META.map(({ key, label }) => (
          <label key={key} className="flex items-center gap-2 text-sm vscode-text-primary cursor-pointer">
            <input
              type="checkbox"
              className="rounded"
              checked={local.includes(key)}
              onChange={() => {
                setLocal((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));
              }}
            />
            {label}
          </label>
        ))}
        <div className="flex justify-end gap-2 pt-4">
          <button type="button" className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={() => {
              const p = loadAiInterviewsTablePolicy(orgId);
              p.extraColumns = local;
              saveAiInterviewsTablePolicy(orgId, p);
              onSave();
              onClose();
            }}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
}
